/* eslint-disable max-len */
import apiClient from '../api';
import { executeAndWaitResponse } from './service';

export const compute = async (payload) => executeAndWaitResponse(() => apiClient.toth.compute(payload));

export default {
  compute,
};
